import { LitElement, css, html } from 'lit'
import { customElement, property, queryAssignedElements, state } from 'lit/decorators.js'
import { isNullishOrWhitespace } from '../functions/nullish';

@customElement('ep-event-proxy')
export class EPEventProxy extends LitElement {
  @property({ attribute: 'events', reflect: true })
  eventsStr: string = 'click';

  get events(): string[] {
    return this.eventsStr.split(',').map(e => e.trim()).filter(e => !isNullishOrWhitespace(e));
  }

  @property({ type: Boolean, attribute: 'debug', reflect: true })
  debug: boolean = false;

  //#region Slots
  @queryAssignedElements({ slot: 'display' })
  displayElements?: HTMLElement[];

  @queryAssignedElements({ slot: 'proxy' })
  proxyElements?: HTMLElement[];

  getDisplayElement(): HTMLElement | undefined {
    return (this.displayElements ?? [])[0];
  }

  getProxyElement(): HTMLElement | undefined {
    return (this.proxyElements ?? [])[0];
  }

  @state()
  currentDisplayElement?: HTMLElement = this.getDisplayElement();

  @state()
  currentProxyElement?: HTMLElement = this.getProxyElement();
  //#endregion
  
  render() {
    return html`
      <slot name="proxy" style="${this.debug ? "" : "display: none;"}" @slotchange=${this._handleProxySlotChange}></slot>
      <slot name="display" @slotchange=${this._handleDisplaySlotChange}></slot>
    `
  }

  private _handleProxySlotChange() {
    // store reference
    this.currentProxyElement = this.getProxyElement();
  }

  private _handleDisplaySlotChange() {
    const displayElement = this.getDisplayElement();
    if (displayElement) {
      //console.log('handleDisplaySlotChange - setup listeners')
      // remove listeners from old element
      for(let eventName of this.events) {
        this.currentDisplayElement?.removeEventListener(eventName as any, this._handleDisplayEvent.bind(this));
      }
      // set element as current element
      this.currentDisplayElement = displayElement
      // add listeners to new element
      for(let eventName of this.events) {
        this.currentDisplayElement.addEventListener(eventName as any, this._handleDisplayEvent.bind(this));
      }
    }
  }

  private _handleDisplayEvent(event: Event) {
    if (this.currentDisplayElement && this.currentProxyElement) {
      if(event.type === 'click') {
        this.currentProxyElement.click();
      }
      else {
        const synthEvent = new CustomEvent(event.type, { detail: { originalEvent: event }});
        this.currentProxyElement.dispatchEvent(synthEvent);
      }
    }
  }

  static styles = css`
    :host {
      display: contents;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-event-proxy': EPEventProxy
  }
}
